import type { RemediationStrategy } from '../types';
import { breakAllowanceStrategy } from './breakAllowanceStrategy';
import { restPeriodStrategy } from './restPeriodStrategy';
import { shiftLengthStrategy } from './shiftLengthStrategy';
import { workloadStrategy } from './workloadStrategy';

export { breakAllowanceStrategy, restPeriodStrategy, shiftLengthStrategy, workloadStrategy };

export const defaultStrategies: readonly RemediationStrategy[] = [
  breakAllowanceStrategy,
  restPeriodStrategy,
  shiftLengthStrategy,
  workloadStrategy,
];

export interface StrategyRegistry {
  resolve(ruleCode: string): RemediationStrategy | null;
}

/** Maps each rule code to the strategy that fixes it; a code claimed twice is a wiring mistake. */
export function createStrategyRegistry(strategies: readonly RemediationStrategy[]): StrategyRegistry {
  const byRuleCode = new Map<string, RemediationStrategy>();
  strategies.forEach((strategy) => strategy.ruleCodes.forEach((ruleCode) => {
    if (byRuleCode.has(ruleCode)) {
      throw new Error(`Two remediation strategies claim rule "${ruleCode}"`);
    }
    byRuleCode.set(ruleCode, strategy);
  }));

  return {
    resolve: (ruleCode) => byRuleCode.get(ruleCode) ?? null,
  };
}
